<template>
	<div class="container"><slot></slot></div>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.container {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	@media screen and (max-width: 1280px) {
		grid-template-columns: repeat(2, 1fr);
	}
}
</style>
